import React, { useState } from "react";
import "../Styles.css";
import { UseGlobalState } from "../../state/gsh/gsh";
import { Image } from "@fluentui/react-northstar";

import { DOMAIN_PANE, HELP_PANE, NONE } from "./constants";

export default function DomainPane(props) {
  const { clickFunc } = props;

  const [state, setState] = UseGlobalState();
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      clickFunc(document.getElementById("program-url").value, setErrorMessage);
    }
  };

  const handleHelpClick = () => {
    state.loginPane = HELP_PANE;
    setState(state);
  };

  return (
    <div>
      {loading && (
        <div class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-40 overflow-hidden bg-white flex flex-col items-center justify-center">
          <div class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"></div>
        </div>
      )}
      {state.loginPane === DOMAIN_PANE && (
        <div className="reactModalProgURL">
          <div className="loginModalProgURLBody1">
            <Image src="color.png" className="cnxt-logo" />
            &nbsp;&nbsp;
            <span className="loginModalProgURLBody12">CultureNext</span>
          </div>
          <br />
          <div className="loginModalProgURLBody0">
            <div className="loginModalProgURLBody2">
              Enter your recognition program URL
            </div>
            <div>
              <span className="text-black">www. </span>
              <input
                className="loginModalProgURLBody3"
                type="text"
                id="program-url"
                placeholder="program-url"
                onKeyPress={handleKeyPress}
              ></input>
              <span className="text-black"> .culturenxt.com</span>
            </div>
            {errorMessage && (
              <div className="loginModalError">
                <span> {errorMessage} </span>
              </div>
            )}
            <br />
            <div>
              <button
                className="loginModalProgURLBody4"
                onClick={() => {
                  clickFunc(
                    document.getElementById("program-url").value,
                    setErrorMessage
                  );
                }}
              >
                Continue
              </button>
            </div>

            <div className="loginModalProgURLBody5">
              <a
                href="#"
                onClick={() => {
                  handleHelpClick();
                  return false;
                }}
              >
                Don’t know your recognition program URL?
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
